export enum SystempayRestApiErrorCodeEnum {
    ACQ_PAYMENT_REFUSED = "ACQ_001",
    ACQ_TECHNICAL_ERROR = "ACQ_999",
    AUTH_INVALID_ACS_SIGNATURE = "AUTH_100",
    AUTH_TECHNICAL_ERROR_THREEDS = "AUTH_101",
    AUTH_WRONG_PARAMETER_THREEDS = "AUTH_102",
    AUTH_THREEDS_DISABLED = "AUTH_103",
    AUTH_THREEDS_OPERATION_TIMEOUT = "AUTH_149",
    AUTH_TECHNICAL_ERROR = "AUTH_999",
    // there is a huge list of INT_ errors, full list here: https://paiement.systempay.fr/doc/en-EN/rest/V4.0/api/errors_int.html
    INT_INVALID_INPUT_PARAMETER = "INT_001",
    INT_FORM_TOKEN_PARAMETER_NOT_VALID = "INT_885",
    INT_FORM_TOKEN_NOT_FOUND = "INT_903",
    INT_INVALID_PUBLIC_KEY = "INT_904",
    INT_FORM_TOKEN_INVALID = "INT_906",
    INT_TECHNICAL_ERROR = "INT_999",
    // there is a huge list of PSP_ errors, full list here: https://paiement.systempay.fr/doc/en-EN/rest/V4.0/api/errors_psp.html
    PSP_UNAUTHORIZED_ACTION = "PSP_001",
    PSP_INVALID_ATTRIBUTE = "PSP_002",
    PSP_PAYMENT_REFUSED = "PSP_003",
    PSP_TRANSACTION_NOT_FOUND = "PSP_010",
    PSP_TRANSACTION_STATUS_INCORRECT = "PSP_011",
    PSP_TRANSACTION_ALREADY_EXISTS = "PSP_012",
}